var map = {
	"./Anyswap.png": 482,
	"./Anyswap.svg": 483,
	"./Artwork.svg": 484,
	"./Artwork_gmx.svg": 485,
	"./Banxa.png": 486,
	"./DROP_DOWN.svg": 284,
	"./Frame.svg": 487,
	"./Hop.png": 488,
	"./Hop.svg": 489,
	"./Hop_dark.png": 490,
	"./Hop_dark.svg": 491,
	"./Synapse.png": 492,
	"./Synapse.svg": 493,
	"./binance.png": 494,
	"./bscscan.png": 495,
	"./btn_big_arbitrum.png": 496,
	"./btn_big_avalanche.png": 497,
	"./btn_big_bsc.png": 498,
	"./btn_big_purchasegmx.png": 499,
	"./btn_big_purchasegmx.svg": 500,
	"./buy_gmx.svg": 285,
	"./buy_gmx_bond.svg": 501,
	"./buy_transfer_eth.svg": 502,
	"./coinbaseWallet.png": 286,
	"./coingecko.png": 503,
	"./cross.svg": 504,
	"./flag_en.svg": 505,
	"./flag_es.svg": 506,
	"./flag_fr.svg": 507,
	"./flag_ja.svg": 508,
	"./flag_ko.svg": 509,
	"./flag_ru.svg": 510,
	"./flag_zh.svg": 511,
	"./glp_icon.svg": 512,
	"./gmx-logo-final-white-small.png": 513,
	"./gmx-logo-final-white.png": 514,
	"./gmx-logo-final.png": 515,
	"./gmx-logo-glow.png": 516,
	"./gmx-logo-with-name.svg": 287,
	"./gmx_logo.svg": 517,
	"./graphite-01.png": 518,
	"./ic-communityproject.svg": 519,
	"./ic_aave_24.svg": 520,
	"./ic_aave_30.svg": 521,
	"./ic_aave_40.svg": 522,
	"./ic_arbitrum_16.svg": 128,
	"./ic_arbitrum_24.svg": 171,
	"./ic_arbitrum_96.svg": 172,
	"./ic_arbitrum_hover_16.svg": 523,
	"./ic_arrowleft16.svg": 524,
	"./ic_arrowright16.svg": 525,
	"./ic_avalanche_16.svg": 288,
	"./ic_avalanche_24.svg": 526,
	"./ic_avalanche_96.svg": 173,
	"./ic_avax_24.svg": 527,
	"./ic_avax_30.svg": 528,
	"./ic_avax_40.svg": 529,
	"./ic_banxa.svg": 289,
	"./ic_binance.svg": 530,
	"./ic_binance_logo.svg": 531,
	"./ic_bsc.svg": 532,
	"./ic_bsc_96.svg": 533,
	"./ic_btc.b_24.svg": 534,
	"./ic_btc.b_40.svg": 535,
	"./ic_btc_24.svg": 536,
	"./ic_btc_40.svg": 537,
	"./ic_bungee.png": 290,
	"./ic_busd_24.svg": 538,
	"./ic_buy_glp.svg": 291,
	"./ic_cash.png": 539,
	"./ic_cash.svg": 540,
	"./ic_checked.svg": 200,
	"./ic_coingecko_16.svg": 292,
	"./ic_coingecko_hover_16.svg": 541,
	"./ic_convert_down.svg": 293,
	"./ic_copy_16.svg": 294,
	"./ic_cost.svg": 295,
	"./ic_dai_24.svg": 542,
	"./ic_dai_40.svg": 543,
	"./ic_discord.svg": 296,
	"./ic_eth_24.svg": 544,
	"./ic_eth_40.svg": 545,
	"./ic_frax_24.svg": 546,
	"./ic_frax_40.svg": 547,
	"./ic_github.svg": 297,
	"./ic_glp_24.svg": 241,
	"./ic_glp_40.svg": 201,
	"./ic_glp_40_.svg": 548,
	"./ic_glp_custom.svg": 298,
	"./ic_glp_custom_.svg": 549,
	"./ic_gmx.svg": 550,
	"./ic_gmx_24.svg": 551,
	"./ic_gmx_30.svg": 552,
	"./ic_gmx_40.svg": 299,
	"./ic_gmx_40_.svg": 553,
	"./ic_gmx_64.svg": 554,
	"./ic_gmx_arbitrum.svg": 555,
	"./ic_gmx_avax.svg": 556,
	"./ic_gmx_big.svg": 557,
	"./ic_gmx_custom.svg": 300,
	"./ic_gmx_custom_.svg": 558,
	"./ic_gmx_footer.svg": 301,
	"./ic_gmx_footer_.svg": 559,
	"./ic_hop.svg": 560,
	"./ic_info.svg": 561,
	"./ic_language24.svg": 174,
	"./ic_link.e_40.svg": 562,
	"./ic_link_24.svg": 563,
	"./ic_link_40.svg": 564,
	"./ic_liquidity.svg": 302,
	"./ic_mai_24.svg": 565,
	"./ic_mai_40.svg": 566,
	"./ic_matic_16.svg": 140,
	"./ic_matic_24.svg": 175,
	"./ic_matic_40.svg": 567,
	"./ic_medium.svg": 303,
	"./ic_menu_dots.svg": 568,
	"./ic_metamask_16.svg": 304,
	"./ic_metamask_hover_16.svg": 569,
	"./ic_mim_24.svg": 570,
	"./ic_mim_40.svg": 571,
	"./ic_multiswap.svg": 572,
	"./ic_new_link_16.svg": 305,
	"./ic_o3.png": 306,
	"./ic_olympus.svg": 573,
	"./ic_olympus_arbitrum.svg": 307,
	"./ic_selector_dropdowns.svg": 574,
	"./ic_settings_16.svg": 242,
	"./ic_settings_24.svg": 575,
	"./ic_sign in_16.svg": 576,
	"./ic_sign_out_16.svg": 308,
	"./ic_simpleswaps.svg": 309,
	"./ic_stats.svg": 310,
	"./ic_stats_big.svg": 577,
	"./ic_stmatic_24.svg": 578,
	"./ic_stmatic_40.svg": 579,
	"./ic_synapse.svg": 580,
	"./ic_telegram.svg": 311,
	"./ic_tether_24.svg": 581,
	"./ic_tokens.svg": 582,
	"./ic_totaluser.svg": 312,
	"./ic_traderjoe.png": 313,
	"./ic_trading.svg": 314,
	"./ic_transfer_avax.svg": 583,
	"./ic_twitter.svg": 315,
	"./ic_uni_24.svg": 584,
	"./ic_uni_40.svg": 585,
	"./ic_uni_arbitrum.svg": 316,
	"./ic_usdc.e_24.svg": 586,
	"./ic_usdc.e_40.svg": 587,
	"./ic_usdc_24.svg": 588,
	"./ic_usdc_40.svg": 589,
	"./ic_usdt_24.svg": 590,
	"./ic_usdt_40.svg": 591,
	"./ic_wallet_24.svg": 317,
	"./ic_wavax_24.svg": 592,
	"./ic_wavax_40.svg": 593,
	"./ic_wbtc_24.svg": 594,
	"./ic_wbtc_40.svg": 595,
	"./ic_weth_24.svg": 596,
	"./ic_weth_40.svg": 597,
	"./ic_wmatic_24.svg": 598,
	"./ic_wmatic_40.svg": 599,
	"./lg_arbitrum.svg": 600,
	"./logo_GMX.svg": 176,
	"./logo_GMX_.svg": 601,
	"./logo_GMX_small.svg": 243,
	"./logo_GMX_small_.svg": 602,
	"./long.svg": 318,
	"./metamask-text.svg": 603,
	"./metamask.png": 319,
	"./page-not-found.svg": 604,
	"./position-share-bg.png": 320,
	"./short.svg": 321,
	"./swap.svg": 322,
	"./trading.jpg": 605,
	"./wallet-connect-text.svg": 606,
	"./walletconnect-circle-blue.svg": 323,
	"./wave-01.png": 607,
	"./wave-02.png": 608
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 481;